import { z } from 'zod';

export const BaseAutocompleteQuery = z.object({
  environmentName: z.string().optional(),
  searchTerms: z.array(z.string()).default([]),
  limit: z.number().int().positive().max(100).default(20).optional(),
});

export const ServicesAutocompleteQuery = BaseAutocompleteQuery.extend({
  selectedIds: z.array(z.coerce.number()).optional(),
});
export type ServicesAutocompleteQuery = z.infer<
  typeof ServicesAutocompleteQuery
>;

export const ServicesAutocompleteResponse = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
  }),
);

export type ServicesAutocompleteResponse = z.infer<
  typeof ServicesAutocompleteResponse
>;

// filePath autocomplete
export const FilePathAutocompleteQuery = BaseAutocompleteQuery.extend({
  serviceId: z.coerce.number().optional(),
  selectedPaths: z.array(z.string()).optional(),
});

export type FilePathAutocompleteQuery = z.infer<
  typeof FilePathAutocompleteQuery
>;

export const FilePathAutocompleteResponse = z.array(
  z.object({
    filePath: z.string(),
  }),
);

export type FilePathAutocompleteResponse = z.infer<
  typeof FilePathAutocompleteResponse
>;

export const EndpointsAutocompleteQuery = BaseAutocompleteQuery.extend({
  selectedIds: z.array(z.coerce.string()).optional(),
});

export type EndpointsAutocompleteQuery = z.infer<
  typeof EndpointsAutocompleteQuery
>;

export const EndpointsAutocompleteResponse = z.array(
  z.object({
    id: z.number(),
    path: z.string(),
    method: z.string(),
  }),
);

export type EndpointsAutocompleteResponse = z.infer<
  typeof EndpointsAutocompleteResponse
>;

export const FunctionsAutocompleteQuery = BaseAutocompleteQuery.extend({
  selectedIds: z.array(z.coerce.number()).optional(),
});
export type FunctionsAutocompleteQuery = z.infer<
  typeof FunctionsAutocompleteQuery
>;

export const FunctionsAutocompleteResponse = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
  }),
);
export type FunctionsAutocompleteResponse = z.infer<
  typeof FunctionsAutocompleteResponse
>;

export const MethodsAutocompleteQuery = BaseAutocompleteQuery.extend({
  selectedMethods: z.array(z.string()).optional(),
});
export type MethodsAutocompleteQuery = z.infer<typeof MethodsAutocompleteQuery>;

export const MethodsAutocompleteResponse = z.array(
  z.object({
    method: z.string(),
  }),
);
export type MethodsAutocompleteResponse = z.infer<
  typeof MethodsAutocompleteResponse
>;
